// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getOrderDetailsVMList(order_info, partner_info) {
  return [
          {
            label: "Order",
            value: order_info.order_id
          },
          {
            label: "Order Date",
            value: Timestamp$Catalyst.toString(order_info.order_time, "DD/MM/YY hh:mm A")
          },
          {
            label: "Driver",
            value: partner_info.name
          },
          {
            label: "MSISDN",
            value: partner_info.msisdn
          },
          {
            label: "Vehicle",
            value: partner_info.vehicle_type
          }
        ];
}

function getPenaltyTypeOptions(penalty_list) {
  return List.map((function (penalty) {
                return {
                        key: "",
                        value: String(penalty.id),
                        text: penalty.name
                      };
              }), penalty_list);
}

function getVM(penalty_list_response) {
  return {
          orderDetailsVMList: getOrderDetailsVMList(penalty_list_response.order_info, penalty_list_response.partner_info),
          penaltyTypeOptions: getPenaltyTypeOptions(penalty_list_response.penalty_list)
        };
}

export {
  getOrderDetailsVMList ,
  getPenaltyTypeOptions ,
  getVM ,
  
}
/* Timestamp-Catalyst Not a pure module */
